import { render, staticRenderFns } from "./invoice-fail.vue?vue&type=template&id=0828ec84&scoped=true&"
import script from "./invoice-fail.vue?vue&type=script&lang=js&"
export * from "./invoice-fail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-fail.vue?vue&type=style&index=0&id=0828ec84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828ec84",
  null
  
)

export default component.exports